import React, { useEffect, useState } from "react";
import Datas from "../data/course/filter.json";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/courseFilter.js";
import { Constant, imageDomain } from "../helper/Constants.js";
import axios from "axios";

function CourseFilter() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 🟢 Helper → Remove HTML tags + limit to 100 chars
  const getCleanDescription = (html = "") => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    const text = temp.textContent || temp.innerText || "";

    return text.length > 100 ? text.substring(0, 100) + "..." : text;
  };

  // 🟢 Build correct image URL
  const buildImageUrl = (img = "") => {
    if (!img) return process.env.PUBLIC_URL + "/assets/images/default-course.jpg";
    if (/^https?:\/\//i.test(img)) return img;
    if (imageDomain)
      return imageDomain.replace(/\/$/, "") + (img.startsWith("/") ? img : "/" + img);

    return (process.env.PUBLIC_URL || "") + (img.startsWith("/") ? img : "/" + img);
  };

  // 🟢 Fetch courses on mount
  useEffect(() => {
    getCourses();
  }, []);

  const getCourses = async () => {
    setLoading(true);
    setError(null);

    try {
      const resp = await axios.get(Constant.getUrls.getAllCourses);

      const payload =
        resp?.data?.data?.docs ??
        resp?.data?.data ??
        resp?.data ??
        [];

      const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload.docs)
        ? payload.docs
        : [];

      setCourses(list.slice(0, 6)); // only first 6 courses
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to load courses");
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Styles>
      <section className="course-filter">
        <Container>
          <Row>
            <Col md="12">
              <div className="sec-title text-center">
                <h4>{Datas.secTitle || "Our Courses"}</h4>
              </div>
            </Col>

            <Col md="12">
              <Row className="filter-items">
                {loading ? (
                  <Col md="12" className="text-center">
                    <h5>Loading courses...</h5>
                  </Col>
                ) : error ? (
                  <Col md="12" className="text-center">
                    <h5 style={{ color: "red" }}>{error}</h5>
                  </Col>
                ) : courses.length === 0 ? (
                  <Col md="12" className="text-center">
                    <h5>No courses found</h5>
                  </Col>
                ) : (
                  courses.map((course, i) => {
                    const courseLink = course.slug
                      ? `/course-details/${course.slug}`
                      : `/course-details/${course._id}`;

                    const poster = course.image || "";
                    const authorImg = "/assets/images/default-author.png";
                    const price = course.price || "Free";
                    const duration = course.duration || "0";
                    const rating = course.rating || 0;
                    const students = course.students || 0;

                    return (
                      <Col lg="4" md="6" key={i}>
                        <div className="course-item">
                          <Link to={process.env.PUBLIC_URL + courseLink}>
                            <div
                              className="course-image"
                              style={{
                                backgroundImage: `url(${buildImageUrl(poster)})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                              }}
                            >
                              <div className="author-img d-flex">
                                <div className="img">
                                  <img
                                    src={buildImageUrl(authorImg)}
                                    alt="Instructor"
                                  />
                                </div>
                                <div className="title">
                                  <p>Instructor</p>
                                  <span>Course Expert</span>
                                </div>
                              </div>

                              <div className="course-price">
                                <p>{typeof price === "number" ? `₹ ${price}` : price}</p>
                              </div>
                            </div>
                          </Link>

                          <div className="course-content">
                            <h6 className="heading">
                              <Link to={process.env.PUBLIC_URL + courseLink}>
                                {course.course_name || "Untitled Course"}
                              </Link>
                            </h6>

                            {/* Clean description */}
                            <p className="desc">
                              {getCleanDescription(course.description || "")}
                            </p>

                            <div className="course-face d-flex justify-content-between">
                              <div className="duration">
                                <p>
                                  <i className="las la-clock"></i>
                                  {duration}
                                </p>
                              </div>

                              <div className="rating">
                                <ul className="list-unstyled list-inline">
                                  {Array.from({ length: 5 }).map((_, idx) => {
                                    const starFull = idx < Math.floor(rating);
                                    const halfStar =
                                      !starFull && rating - Math.floor(rating) >= 0.5;
                                    return (
                                      <li className="list-inline-item" key={idx}>
                                        {starFull ? (
                                          <i className="las la-star"></i>
                                        ) : halfStar ? (
                                          <i className="las la-star-half-alt"></i>
                                        ) : (
                                          <i className="las la-star"></i>
                                        )}
                                      </li>
                                    );
                                  })}
                                  <li className="list-inline-item">({rating})</li>
                                </ul>
                              </div>

                              <div className="student">
                                <p>
                                  <i className="las la-chair"></i>
                                  {students}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })
                )}
              </Row>
            </Col>

            <Col md="12" className="text-center">
              <div className="viewall-btn">
                <Link to={process.env.PUBLIC_URL + "/course-grid"}>
                  View All Courses
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
}

export default CourseFilter;
